import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
  position: relative;
  width: 100%;
  height: 16px;
  margin-bottom: 1rem;
  padding: 0 1rem;
  &:before {
    z-index: 10;
    content: '';
    clip-path: polygon(
      0% 100%,
      calc(100% - 9px) 100%,
      100% 0,
      calc(100% - 15px) 0%,
      calc(100% - 19px) 6px,
      0% 6px
    );
    width: calc(50% - 1rem);
    height: 14px;
    position: absolute;
    left: 1rem;
    top: 0;
    background: ${({ theme }) => theme.colors.black};
  }
  &:after {
    z-index: 10;
    content: '';
    clip-path: polygon(100% 0%, 9px 0%, 0% 100%, 15px 100%, 20px 7px, 100% 7px);
    width: calc(50% - 1rem);
    height: 14px;
    position: absolute;
    right: 1rem;
    top: 0;
    background: ${({ theme }) => theme.colors.black};
  }
`

const Separator = () => {
  return <Wrap />
}

export default Separator
